import React from "react"
import { DEFAULT_SIZE } from "utils/icons"

const FileImportIcon = ({
  size = DEFAULT_SIZE,
  color = "currentColor"
 }) => {
	return (
		<svg
      xmlns="http://www.w3.org/2000/svg"
      height={size}
      width={size}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path fill={color} d="M6 22.5h12a2.503 2.503 0 0 0 2.5-2.5V7.829a2.484 2.484 0 0 0-.732-1.768l-3.829-3.829a2.484 2.484 0 0 0-1.768-.732H6A2.503 2.503 0 0 0 3.5 4v16A2.503 2.503 0 0 0 6 22.5Zm8.5-19.961a1.49 1.49 0 0 1 .732.4l3.829 3.829a1.49 1.49 0 0 1 .4.732H16A1.502 1.502 0 0 1 14.5 6ZM4.5 4A1.502 1.502 0 0 1 6 2.5h7.5V6A2.503 2.503 0 0 0 16 8.5h3.5V20a1.502 1.502 0 0 1-1.5 1.5H6A1.502 1.502 0 0 1 4.5 20Zm4.146 11.354a.5.5 0 0 1 0-.707l3-3a.5.5 0 0 1 .707.707L10.207 14.5H15a.5.5 0 0 1 0 1h-4.793l2.146 2.146a.5.5 0 1 1-.707.707Z"/>
    </svg>
	)
}

export default FileImportIcon

